/*
 * Copyright © 2023 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

import React, { ReactElement, ReactNode } from "react"

const boxShadow = "0 1.2px 3.6px 0px rgb(0 0 0 / 0.11), 0 6.4px 14.4px 0px rgb(0 0 0 / 0.13)"

const PopupContainer = ({ children }: { children: ReactNode }): ReactElement => {
  return (
    <div className="bg-white rounded-md p-2" style={{ boxShadow }}>
      {children}
    </div>
  )
}

export default PopupContainer
